<template>
  <div id="contenedor-main-licitacion-participantes">
    <tool-bar v-on:registrarParticipante="mostrarVentanaRegistarParticipante = true" />
    <listado />
    <v-dialog
      v-model="mostrarVentanaRegistarParticipante"
      width="500">
      <registrar-nuevo-participante
        :idLicitacion="idLicitacion"
        v-on:cerrar="mostrarVentanaRegistarParticipante = false"/>
    </v-dialog>
    <v-dialog
      v-model="mostrarVentanaEliminarParticipante"
      width="500">
      <eliminar-participante
        :participanteEliminar="esteParticipante"
        v-on:cerrar="mostrarVentanaEliminarParticipante = false"/>
    </v-dialog>
  </div>
</template>

<script>
// import LICITACIONES from '@/graphql/querys/administracion/licitaciones/licitaciones.gql';
import RegistrarNuevoParticipante from '@/components/administracion/licitaciones/participantes/Nuevo.vue';
import EliminarParticipante from '@/components/administracion/licitaciones/participantes/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'MainLicitacionParticipantes',
  components: {
    ToolBar,
    Listado,
    RegistrarNuevoParticipante,
    EliminarParticipante,
  },
  // apollo: {
  //   licitaciones: {
  //     query: LICITACIONES,
  //   },
  // },
  data() {
    return {
      mostrarVentanaRegistarParticipante: false,
      mostrarVentanaEliminarParticipante: false,
      esteParticipante: null,
      idLicitacion: this.$route.params.idLicitacion,
    };
  },
  mounted() {
    eventBus.$on('eliminar-participante', (participante) => {
      this.esteParticipante = participante;
      this.mostrarVentanaEliminarParticipante = true;
    });
  },
  methods: {},
//   computed: {
//     licitacion() {
//       if (!this.licitaciones) return {};
//       return this.licitaciones.find((elem) => elem.id === this.$route.params.idLicitacion);
//     },
//   },
};
</script>

<style lang="scss">

</style>
